// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__Uk_1u","row":"Node_row__1QAow","label":"Node_label__cJd2G","footer":"Node_footer__Up8A9"};